export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Aptitude Plus logo" data-testid="logo-mark">
    <rect width="64" height="64" rx="16" fill="#1C242B" />
    <rect x="27" y="27" width="24" height="10" rx="5" fill="#D96B43" />
    <rect x="13" y="27" width="24" height="10" rx="5" fill="#FAF8F5" />
    <rect x="27" y="13" width="10" height="38" rx="5" fill="#FAF8F5" />
    <circle cx="50" cy="14" r="4" fill="#3E6B5C" />
  </svg>
);
